<template>
  <div>
    <!--关键词维护  -->
    <baseBreadcrumb :page="$t('message.customerSearchKeywordMaintenance')"
      :menu="$t('message.operationAndMaintenance')" />
    <div class="tabs">
      <el-tabs v-model="datas.keywords_status" type="card" @tab-click="tabClick">
        <!-- 全部 -->
        <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane>
        <!-- 待修改 -->
        <el-tab-pane :label="$t('message.backlog') + `(${tabs[0].num})`" name="1"></el-tab-pane>
        <!-- 已修改 -->
        <el-tab-pane :label="$t('message.modified')" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search">
      <!-- 修改日期 -->
      <span>{{ $t('message.searchDate') }} ：</span>
      <div class="input">
        <el-date-picker v-model="dateArr" type="daterange" range-separator="-"
          :start-placeholder="$t('message.startDate')" :end-placeholder="$t('message.dateClosed')"
          value-format="yyyy-MM-dd ">
        </el-date-picker>
      </div>
      <div class="input">
        <el-input v-model="datas.keywords" :placeholder="$t('message.keyword')"></el-input>
      </div>
      <div class="input">
        <el-select v-model="datas.searchType" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!-- 筛选 -->
      <el-button type="primary" @click="search"> {{ $t('message.filter') }}</el-button>
      <!-- 批量确认 -->
      <el-button type="primary" class="fr" @click="searchKeywordsConfirm" v-if="isAuth(404)">
        {{ $t('message.BatchConfirmation') }}
      </el-button>
      <!--  批量修改-->
      <el-button type="primary" class="fr" @click="modifyBatch" v-if="isAuth(403)">
        {{ $t('message.BulkChanges') }}</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%" border :header-cell-style="{ background: '#EDEFF4' }"
        @selection-change="handleSelectionChange">
        <el-table-column type="index" label="NO" align="center">
        </el-table-column>

        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <!-- 搜索时间 -->
        <el-table-column prop="created_at" :label="$t('message.searchTime')" align="center">
        </el-table-column>
        <!-- 客户输入的关键词 -->
        <el-table-column prop="keywords" :label="$t('message.KeywordsEnteredByTheCustomer')" align="center">
        </el-table-column>
        <!-- 谷歌自动翻译结果-->
        <el-table-column prop="keywords1" :label="$t('message.GoogleAutomaticallyTranslatesTheResults')" align="center">
        </el-table-column>
        <!-- 人工修改中文关键词 -->
        <el-table-column prop="keywordsCh" :label="$t('message.ManuallyModifyKeywords')" align="center">
        </el-table-column>
        <!--  搜索结果-->
        <el-table-column :label="$t('message.searchResult')" align="center" width="110px">
          <template slot-scope="scope">
            <a :href="'https://www.rakumart.com/CommoditySearch?keyword=' + scope.row.keywords" target="_blank"
              rel="noopener noreferrer">
              <el-button type="text">{{ $t('message.look') }}</el-button>
            </a>
          </template>
        </el-table-column>
        <!--  修改时间-->
        <el-table-column prop="updated_at" :label="$t('message.maintenanceTime')" align="center" width="100px">
        </el-table-column>
        <!-- 修改人 -->
        <el-table-column prop="option_admin_name" :label="$t('message.maintenanceName')" align="center" width="100px">
        </el-table-column>
        <!--  状态-->
        <el-table-column :label="$t('message.status')" align="center" width="100px">
          <template slot-scope="scope">
            {{ scope.row.keywords_status == 1 ? "待修改" : "已修改" }}
          </template>
        </el-table-column>
        <!-- 操作-->
        <el-table-column :label="$t('message.operation')" align="center" width="80px">
          <template slot-scope="scope">
            <a href="javascript:;" @click="trueModify(scope.row)" v-if="isAuth(403)">{{ $t('message.edit') }}</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fenye">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 修改 -->
    <!-- 人工关键词 -->
    <el-dialog :title="$t('message.ManuallyModifyKeywords')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="500px" center>
      <ul class="weihu">
        <!--客户输入的词  -->
        <li>
          <span>{{ $t('message.WordsEnteredByTheCustomer') }}：</span><span>{{ modifyDate.keywords }}</span>
        </li>
        <!-- 谷歌自动翻译中文 -->
        <li>
          <span>{{ $t('message.GoogleAutomaticallyTranslatesTheResults') }}：</span><span>{{ modifyDate.keywords1
            }}</span>
        </li>
        <li v-for="(item, index) in namebrModfiyArr" :key="index">
          <!-- 人工修改中文关键词 -->
          <span>{{ $t('message.ManuallyModifyKeywords') }}：</span>
          <span><el-input size="mini" type="textarea" resize="none" v-model="item.name"></el-input>
            <i class="el-icon-circle-close" @click="delNamebrModfiyArr(index)"></i>
          </span>
        </li>
        <li>
          <span>
            <!-- 追加 -->
            <el-button type="primary" size="mini" @click="addNamebrModfiyArr">{{ $t('message.additional')
              }}</el-button></span>
          <span></span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <!--  取 消-->
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <!-- 确 定 -->
        <el-button type="primary" @click="searchKeywordsModfiy">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>
    <!-- 批量 -->
    <!--人工关键词批量修改  -->
    <el-dialog :title="$t('message.ArtificialKeywordsBatchModification')" :close-on-click-modal="false"
      :visible.sync="modifyDialogVisible" width="750px" center>
      <div class="content">
        <div class="contents">
          <!-- 查找内容 -->
          <span>{{ $t('message.ToFindTheContent') }}：</span> <input type="text" v-model="findData" />
        </div>

        <div class="contents">
          <!-- 替换内容 -->
          <span>{{ $t('message.AlternativeContent') }}：</span> <input type="text" v-model="replaceData" />
          <!--  确认-->
          <el-button type="primary" size="small" @click="replaceAll">{{ $t('message.confirm') }}</el-button>
          <!-- 填充谷歌关键词值 -->
          <el-button type="primary" size="small" class="fr" @click="filler(2)">{{
      $t('message.fillInTheGoogleKeywordValue')
    }}</el-button>
          <!-- 填充客户输入关键词值 -->
          <el-button type="primary" size="small" class="fr" @click="filler(1)">{{
      $t('message.fillInTheCustomerInputKeywordValues') }}</el-button>

        </div>
        <div class="table">
          <!--     :key="Math.random()" -->
          <el-table :data="modifyArr" style="width: 100%" border
            :header-cell-style="{ background: '#f2f2f2', color: '#333' }" @selection-change="modifySelectionChange">
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <!-- 关键词 -->
            <el-table-column prop="keywords" :label="$t('message.keyword')" align="center">
            </el-table-column>
            <!-- 谷歌自动翻译值 -->
            <el-table-column prop="keywords1" :label="$t('message.googleAutomaticallyTranslatesValues')" align="center">
            </el-table-column>
            <!--  人工修正的关键词-->
            <el-table-column :label="$t('message.artificialCorrectionOfKeywords')" align="center">
              <template slot-scope="scope">
                <el-input size="small" v-model="scope.row.namebrModfiyStr"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="modifyDialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <!-- 确认 -->
        <el-button type="primary" @click="searchKeywordsUpdate">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getDate } from "@/utlis/date";
import { options } from "@/utlis/options";
export default {
  data() {
    return {
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 },],
      dialogVisible: false,
      modifyDialogVisible: false,
      dateArr: [],
      datas: {
        keywords_status: "",
        start_time: "",
        end_time: "",
        page: 1,
        pageSize: 10,
        keywords: "",
        searchType: "",
      },
      tableData: [],
      total: 0,
      options,
      modifyDate: { //当个修改
        keyword: "",
        id: "",
        name: "",
        keywords1: "",
      },
      namebrModfiyArr: [], //批量
      modifyArr: [],
      modifyIdArr: [], //批量修改
      modifySelectData: [],
      findData: "", //查找的值
      replaceData: "",//替换的值
    };
  },
  created() {
    this.searchKeywords();
    this.searchKeywordsTable()
  },
  methods: {
    searchKeywordsTable() {
      this.$api.tabTotalApi.searchKeywordsTable().then(res => {
        this.tabs = res.data
      })
    },
    // 获取列表
    searchKeywords() {
      if (this.dateArr != false && this.dateArr != null) {
        this.datas.start_time = this.dateArr[0];
        this.datas.end_time = this.dateArr[1];
      } else {
        this.datas.start_time = ''
        this.datas.end_time = ''
      }
      this.$api.siteConfiguration.searchKeywords(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          if (item.keywords2) {
            item.keywordsCh = item.keywords2.join(',')
            item.namebrModfiyArr = [];
            item.keywords2.forEach((items) => {
              item.namebrModfiyArr.push({
                name: items,
              });
            });
            item.namebrModfiyStr = item.keywords2[0];
          } else {
            item.namebrModfiyArr = [{ name: item.keywords1 }];
            item.namebrModfiyStr = "";
          }
        });
        this.tableData = res.data.data;
        this.total = res.data.total - 0;
        console.log(this.tableData);
      });
    },
    // 重置页码
    tabClick() {
      this.datas.page = 1;
      this.searchKeywords();
    },
    // 显示修改内容
    trueModify(item) {
      this.modifyDate.keywords = item.keywords;
      this.modifyDate.keywords1 = item.keywords1;
      this.modifyDate.id = item.id;
      this.namebrModfiyArr = item.namebrModfiyArr;
      this.dialogVisible = true;
    },
    // 追加修改
    addNamebrModfiyArr() {
      this.namebrModfiyArr.push({ name: "" });
    },
    //删除追加
    delNamebrModfiyArr(i) {
      this.namebrModfiyArr.splice(i, 1);
    },
    // 人工修改中文关键词
    searchKeywordsModfiy() {
      let datas = {
        update: [{
          id: this.modifyDate.id,
          keywords2: [],
        }]
      }
      this.namebrModfiyArr.forEach((item) => {
        datas.update[0].keywords2.push(item.name);
      });
      if (datas.update[0].keywords2 == false) return this.$message.error("未填写修改内容");

      this.$api.siteConfiguration.searchKeywordsUpdate(datas).then((res) => {
        this.$message.success(res.msg);
        this.searchKeywords();
        this.searchKeywordsTable()
        this.dialogVisible = false;
      });
    },
    // 批量修改
    searchKeywordsConfirm() {
      if (this.modifyIdArr == false)
        return this.$message.warning("未选择，无法批量");
      let datas = {
        id: this.modifyIdArr,
      }
      this.$api.siteConfiguration.searchKeywordsConfirm(datas).then((res) => {
        this.$message.success(res.msg);
        this.searchKeywords();
        this.searchKeywordsTable()
      });
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.searchKeywords();
    },
    // 分页
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.searchKeywords();
    },
    // 一页条数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.searchKeywords();
    },
    // 选择中的ID
    handleSelectionChange(val) {
      this.modifyIdArr = [];
      this.modifyArr = val;
      val.forEach((item) => {
        this.modifyIdArr.push(item.id);
      });
    },
    // 显示批量修改的窗口
    modifyBatch() {
      if (this.modifyArr == false)
        return this.$message.warning("未选择，无法批量");
      this.modifyDialogVisible = true;
    },
    // 批量修改选择中的
    modifySelectionChange(val) {
      this.modifySelectData = val;

    },
    //  i == 1 填充谷歌翻译。i==2 填充中文
    filler(i) {
      if (this.modifySelectData == false)
        return this.$message.error("请选择要填充的列表");
      if (i == 1) {
        this.modifySelectData.forEach((item) => {
          item.namebrModfiyStr = item.keywords1;
        });
      } else {
        this.modifySelectData.forEach((item) => {
          item.namebrModfiyStr = item.keywords;
        });
      }

      console.log(this.modifySelectData);
    },
    // 全部替换
    replaceAll() {
      this.modifyArr.forEach((item) => {
        item.namebrModfiyStr = item.namebrModfiyStr.replace(
          this.findData,
          this.replaceData
        );
      });
      this.$forceUpdate();
    },
    searchKeywordsUpdate() {
      let datas = {
        update: [],

      };
      this.modifyArr.forEach((item) => {
        console.log(item);
        datas.update.push({
          id: item.id,
          keywords2: [item.namebrModfiyStr],
        })
      });

      this.$api.siteConfiguration.searchKeywordsUpdate(datas).then((res) => {
        this.$message.success(res.msg);
        this.searchKeywords();
        this.modifyDialogVisible = false;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.tabs {
  margin: 20px 0;
}

.search {

  .input {
    display: inline-block;
    margin-right: 20px;
  }
}

.table {
  margin-top: 20px;

  a {
    color: #005fe3;
  }
}

.weihu {
  li {
    display: flex;
    margin-bottom: 20px;
    font-size: 16px;

    span {
      flex: 1;
      text-align: right;

      &:nth-last-child(1) {
        flex: 1.5;
        margin-left: 10px;
        text-align: left;
        position: relative;

        /deep/.el-textarea__inner {
          width: 90%;
        }

        i {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 0;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
  }
}

.fenye {
  margin: 20px;
  text-align: center;
}

.content {
  .contents {
    margin-bottom: 10px;

    input {
      height: 30px;
      width: 200px;
      padding: 0 5px;
      border: 1px solid #ccc;
      margin-right: 10px;
      border-radius: 5px;
    }
  }

  .table {
    height: 400px;
    overflow-y: auto;
  }
}
</style>